var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAF119"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3418 10C23.6582 10 21.1266 10.952 19.1013 12.576L20.9241 14.592C22.4937 13.472 24.3671 12.856 26.3418 12.856C31.9114 12.856 36.4684 17.896 36.4684 24.056C36.4684 30.216 31.9114 35.256 26.3418 35.256C24.3671 35.256 22.4937 34.64 20.9241 33.52L19 35.48C21.1266 37.048 23.6076 38 26.3418 38C33.3291 38 39 31.728 39 24C39 16.272 33.3291 10 26.3418 10Z",
    fill: "#161717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 26.7134C27.9 26.7134 29 25.4955 29 23.9455C29 22.3955 27.9 21.1776 26.5 21.1776C25.7 21.1776 25 21.6205 24.55 22.2848L19.1 16.3062C18.8 15.9187 18.3 15.9187 18 16.1955L17.9 16.3062L16.75 17.5794C16.4 17.9116 16.4 18.4651 16.65 18.7973L16.75 18.908L18.75 21.1223C18.95 21.3437 18.95 21.7866 18.75 22.008C18.65 22.1187 18.5 22.1741 18.35 22.1741H9.9C9.45 22.1741 9 22.6169 9 23.1152V24.9419C9.05 25.4402 9.4 25.8277 9.9 25.883H18.5C18.8 25.883 19.05 26.1598 19.05 26.4919C19.05 26.6027 19 26.8241 18.9 26.9348L16.9 29.1491C16.55 29.4812 16.55 30.0348 16.8 30.367L16.9 30.4777L18.05 31.7509C18.35 32.083 18.85 32.083 19.15 31.7509L24.6 25.7723C25 26.3259 25.7 26.7134 26.5 26.7134Z",
    fill: "#161717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 29.3333C25.95 29.3333 25.4 29.2267 24.9 29.0667L23 31.0933C24.05 31.68 25.25 32 26.5 32C30.6 32 34 28.3733 34 24C34 19.6267 30.6 16 26.5 16C25.25 16 24.05 16.32 23 16.96L24.85 18.9867C25.35 18.7733 25.9 18.6667 26.5 18.6667C29.25 18.6667 31.5 21.0667 31.5 24C31.5 26.9333 29.25 29.3333 26.5 29.3333Z",
    fill: "#161717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSales);
export default __webpack_public_path__ + "static/media/target_sales.c33d0e03db82cace85d9f89da3fd6f14.svg";
export { ForwardRef as ReactComponent };